import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { copyToClipboard } from "@/lib/utils";
import { useCallback, useState } from "react";
import { QRCode } from "react-qrcode-logo";

interface DialogLinkProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  link: string;
}

const QR_COLOR = "#008e4a";
const QR_EYE_RADIUS: [number, number, number, number] = [10, 10, 10, 10];

export default function DialogLink({
  open,
  onOpenChange,
  link,
}: DialogLinkProps) {
  const [copied, setCopied] = useState(false);

  const meetingUrl = `${window.location.origin}/meeting/${link}`;

  const handleCopy = useCallback(() => {
    copyToClipboard(meetingUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [meetingUrl]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center">Liên kết cuộc họp</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4">
          <div className="rounded-lg bg-white p-4">
            <QRCode
              value={meetingUrl}
              size={220}
              fgColor={QR_COLOR}
              bgColor="transparent"
              qrStyle="dots"
              logoImage="/assets/logo_icon.png"
              logoWidth={50}
              logoHeight={50}
              logoPadding={5}
              logoPaddingStyle="circle"
              removeQrCodeBehindLogo
              eyeRadius={[
                { outer: QR_EYE_RADIUS, inner: [5, 5, 5, 5] },
                { outer: QR_EYE_RADIUS, inner: [5, 5, 5, 5] },
                { outer: QR_EYE_RADIUS, inner: [5, 5, 5, 5] },
              ]}
              eyeColor={QR_COLOR}
            />
          </div>
          <div className="flex w-full gap-2">
            <Input
              type="text"
              value={meetingUrl}
              readOnly
              className="flex-1"
              aria-label="Link cuộc họp"
            />
            <Button
              onClick={handleCopy}
              aria-label={copied ? "Đã copy link" : "Copy link cuộc họp"}
              className="min-w-[80px]"
            >
              {copied ? "Đã copy" : "Copy"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
